import round from 'lodash.round'

const calculateAnnualPercentDiscount = (monthlyPrice, annualPrice) => {
    const annualizedMonthlyCost = monthlyPrice * 12
    const discountRatio = (annualizedMonthlyCost - annualPrice) / annualizedMonthlyCost
    return round(discountRatio * 100)
}

export default calculateAnnualPercentDiscount
